/**
 * PRIMARY
 * This palette is used for various button states and outlines, but can also be used for backgrounds, banners and text.
 */
const primary = {
  100: '#EEEEEC',
  200: '#CACBC5',
  300: '#535745',
  400: '#4C4E3E',
  500: '#323429',
};

/**
 * NEUTRAL
 * This palette is used for backgrounds, text, buttons and outlines.
 */
const neutral = {
  100: '#FFFFFF',
  200: '#FBF6F2',
  300: '#F6F0EB',
  400: '#E6DBD2',
  500: '#EAEAEA',
  600: '#A6A6A6',
  700: '#6C6C6C',
  800: '#283333',
  900: '#161716',
};

/**
 * SECONDARY
 * This palette is used for backgrounds and special text.
 */
const secondary = {
  100: '#DFC6AB',
  200: '#CBA478',
  300: '#BE8D56',
  400: '#AB7F4D',
  500: '#85633C',
};

/**
 * TERTIARY
 * This palette is used for backgrounds (specifically on our consultation tips) and as an additional highlight color.
 */
const tertiary = {
  100: '#F9F9FE',
  200: '#F3F3FD',
  300: '#D8D8F8',
  400: '#A2A2BA',
  500: '#4C4C57',
};

/**
 * HIGHLIGHT
 * This palette is used for our text link button style and to highlight new products.
 */
const highlight = {
  100: '#FFDDCD',
  200: '#FFC9AF',
  300: '#FFBB9B',
  400: '#E6A88C',
  500: '#B3836D',
};

/**
 * DECORATION
 * This palette is used for decorative elements.
 */
const decoration = {
  100: '#9E868D',
  200: '#643D48',
  300: '#3D0C1A',
  400: '#370B17',
  500: '#2B0812',
};

/**
 * BACKGROUND
 * This palette is used for backgrounds.
 */
const background = {
  100: '#DAE3E9',
  200: '#C3D2DC',
  300: '#B4C7D3',
  400: '#87959E',
  500: '#515A5F',
};

/**
 * LABELS
 * This palette is used for labels.
 */
const labels = {
  100: '#FAFCFF',
  200: '#F4F9FF',
  300: '#DBEDFF',
  400: '#A4B2BF',
};

/**
 * SUBSCRIPTION
 * This palette is used for our our subscription offering.
 */
const subscription = {
  100: '#FCFFEF',
  200: '#F6FFCD',
  300: '#E2FF5D',
  400: '#A9BF46',
};

/**
 * SUCCESS
 * This palette is used to communicate success for the user, for instance when a
 * payment is completed or a password is correct.
 */
const success = {
  100: '#E0EDE4',
  200: '#BED9C7',
  300: '#EAE8E1',
  400: '#236338',
};

/**
 * ERROR
 * This palette is used to communicate error to the user, for instance when a
 * payment could not be completed or a text field entry is not valid.
 */
const error = {
  100: '#F4E5E3',
  200: '#E8CAC6',
  300: '#B45446',
  400: '#873F35',
};

const safety = {
  /**
   * HIGH SAFETY
   */
  high: {
    100: '#E1F4E4',
    200: '#C2E8C7',
    300: '#3AB549',
    400: '#2C8837',
  },
  /**
   * MODERATE SAFETY
   */
  moderate: {
    100: '#FFF7EC',
    200: '#FEE7C4',
    300: '#FCB040',
    400: '#BD8430',
  },

  /**
   * LOW SAFETY
   */
  low: {
    100: '#FDE8E9',
    200: '#F9B8BB',
    300: '#ED1B23',
    400: '#B2141A',
  },
};

/**
 * PRIMARY SUPPLEMENTS
 * This palette is used for our supplement line.
 */
const supplements1 = {
  100: '#FCF0ED',
  200: '#F7D0C7',
  300: '#E56849',
  400: '#AC4E37',
};

/**
 * SECONDARY SUPPLEMENTS
 * This palette is used for our supplement line.
 */
const supplements2 = {
  100: '#FFFBF2',
  200: '#FFF1D5',
  300: '#FFD378',
  400: '#CCA960',
};

const palettes = {
  transparent: 'transparent',
  primary,
  neutral,
  secondary,
  tertiary,
  highlight,
  decoration,
  background,
  labels,
  subscription,
  success,
  error,
  safety,
  supplements1,
  supplements2,
};

export default palettes;
